Vue.directive("capitalise", {
  update(el) {
    el.value = el.value
      .split(" ")
      .map(a => a && a[0].toUpperCase() + a.toLowerCase().substr(1))
      .join(" ");
  }
});

Vue.filter("toCap", function(value, begin, end) {
  if (!value) return "";
  return value.capitalise();
});

Vue.filter("formatText", function(value, begin, end) {
  if (!value) return "";
  return value.replace("_", " ");
});

Vue.mixin({
  data() {
    return {
      tag: "Mixin",
      ccGlobalObj: {}
    };
  },

  methods: {
    log(tag, message) {
      let env = owConfig.environment;
      if (env === "staging") {
        if (tag) {
        //  console.log(tag + ":", message);
        } else {
         // console.log(message);
        }
      }
    },
    getElements(selector) {
      return document.querySelectorAll(selector);
    },
    matchAttr(elements, attr, val) {
      for (var i = 0; i < elements.length; i++) {
        if (elements[i][attr] == val) return elements[i];
      }
    },
    removeClasses(className, elements) {
      if (elements) {
        if (this.checkArray(elements)) {
          elements.forEach(element => {
            element.classList.remove(className);
          });
        } else {
          elements.classList.remove(className);
        }
      }
    },
    addClasses(className, element) {
      if (element && element.classList) {
        element.classList.add(className);
      }
    },
    checkArray(obj) {
      if (typeof Array.isArray === "undefined") {
        Array.isArray = function(obj) {
          return Object.prototype.toString.call(obj) === "[object Array]";
        };
      }
      return Array.isArray(obj) || obj instanceof NodeList;
    },

    getQueryParameter(param) {
      let params = this.$route.query;
      return params[param];
    },
    setUrlParams(appendToOwConfig) {
      const { owConfig: { creditCard: { isSimpleUrl } = {} } = {} } =
        window || {};

      if (isSimpleUrl) return;

      try {
        const { location: { href: url = "" } = {} } = window || {};
        const queryIndex = url.lastIndexOf("?");
        const queryParams = decodeURIComponent(url.slice(queryIndex + 1));
        const equalIndex = queryParams.indexOf("=");

        if (equalIndex !== -1 && queryParams) {
          const metaData = this.decodeBase64(queryParams.slice(equalIndex + 1));

          if (appendToOwConfig) {
            if (!window.owConfig.metaData) {
              window.owConfig.metaData = {};
            }
            Object.assign(window.owConfig.metaData, metaData);
          } else {
            this.$store.dispatch("storeParamsData", metaData);
          }
        }
      } catch (error) {
       // Raven.captureException(error);
      }
    },
    navigate(path, replace) {
      if (replace === true) {
        this.$router.replace({ path: path });
      } else {
        this.$router.push({ path: path });
      }
    },
    navigateWithProps(name, params, replace, query) {
      if (replace === true) {
        this.$router.replace({ name: name, params: params, query: query });
      } else {
        this.$router.push({ name: name, params: params, query: query });
      }
    },
    navigateBack() {
      this.$router.go(-1);
    },
    decodeBase64Value(value) {
      if (value != null) {
        let decodedValue = decodeURIComponent(value);
        decodedValue = Base64.decode(decodedValue);
        let json = JSON.parse(decodedValue);
        this.log(this.tag, json);
        return json;
      }
    },
    showErrorNotification(
      message = "Payment Failed",
      size = "",
      autoDismiss = false,
      timeout
    ) {
      this.$store.commit(
        "SHOW_NOTIFICATION_ERROR",
        this.getPayload(message, size)
      );
      if (autoDismiss) {
        setTimeout(
          () => this.$store.commit("HIDE_NOTIFICATION"),
          timeout || 6000
        );
      }
    },
    displayErrorNotification( header, message, size ) {
      this.$store.commit("SHOW_NOTIFICATION_ERROR", {
        message,
        size,
        header
      });
    },
    showInfoNotification(message, size = "", autoDismiss = false, timeout) {
      this.$store.commit(
        "SHOW_NOTIFICATION_MESSAGE",
        this.getPayload(message, size)
      );
      if (autoDismiss) {
        setTimeout(
          () => this.$store.commit("HIDE_NOTIFICATION"),
          timeout || 6000
        );
      }
    },
    showSuccessNotification(message, size = "", autoDismiss = false, timeout) {
      this.$store.commit(
        "SHOW_NOTIFICATION_SUCCESS",
        this.getPayload(message, size)
      );
      if (autoDismiss) {
        setTimeout(
          () => this.$store.commit("HIDE_NOTIFICATION"),
          timeout || 6000
        );
      }
    },
    hideNotification() {
      this.$store.commit("HIDE_NOTIFICATION");
    },
    getPayload(message, size) {
      let payload = {
        message: message,
        size: size
      };
      return payload;
    },

    getInstallId() {
      return this.getCookie("install_id");
    },

    getTransactionId() {
      return this.getCookie("transaction_id");
    },

    removeTransactionId() {
      this.deleteCookie("transaction_id");
    },

    guid() {
      return (
        this.s4() +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        this.s4() +
        this.s4()
      );
    },

    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      if (match) {
        return match[2];
      }
    },
    getCookieOrSet(name) {
      let value = this.getCookie(name);
      if (!value) {
        const value = this.guid();
        this.setCookie(name, value);
      }
      return value;
    },
    setCookie(name, value) {
      let domain = window.owConfig.trackingCookieDomain;
      document.cookie = name + "=" + value + ";secure;path=/;domain=" + domain;
    },
    deleteCookie(name) {
      let domain = window.owConfig.trackingCookieDomain;
      let expires = new Date().toUTCString();
      this.log(
        "deleteCookie",
        name +
          "=" +
          "" +
          ";secure;path=/;domain=" +
          domain +
          ";expires=" +
          expires
      );
      document.cookie =
        name +
        "=" +
        "" +
        ";secure;path=/;domain=" +
        domain +
        ";expires=" +
        expires;
    },
    materializeInput(selector) {
      let inputs = this.getElements(selector);
      inputs.forEach(element => {
        element.addEventListener("focus", event => {
          let sibling = this.sibling(element, "LABEL");
          this.addClasses("active", sibling);
        });
        element.addEventListener("blur", event => {
          if (event.target.value.length > 0) {
            event.stopPropagation();
            return;
          }
          let sibling = this.sibling(element, "LABEL");
          this.removeClasses("active", sibling);
        });
      });
    },
    sibling(element, selector) {
      let node = element;
      let sibling = node.nextElementSibling;
      while (sibling) {
        if (sibling.tagName == selector) {
          return sibling;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
    },

    fixParentOverflow(selector) {
      let element = document.getElementById(selector);
      if (!element) {
        try {
          element = document.getElementsByClassName(selector)[0];
        } catch (e) {}
      }

      if (element) {
        element.style.overflow = "hidden";
      }
    },

    findAncestor(
      el,
      parentWrapper = "input-field",
      terminateClass = "last-ele",
      nextTargetTagname = "INPUT"
    ) {
      while ((el = el.parentElement) && !el.classList.contains(parentWrapper));
      if (el.classList.contains(terminateClass)) return false;
      el = el.nextElementSibling;
      el = Array.from(el.children).find(
        ele => (ele.tagname = nextTargetTagname)
      );
      return el;
    },

    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
        return "android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
      }
      return "unknown";
    },

    sendRSACleverTapEvent(payload, evtName) {
      const body = {
        evt_name: evtName
      };
      if (typeof payload === "string") {
        body["properties"] = {
          page_name: payload
        };
      } else {
        body["properties"] = payload;
      }
      this.$store.dispatch("sendCleverTapEvent", body);
    },

    sendCleverTapEvent(evtName, pageName, properties) {
      const body = {
        evt_name: `ofs_cc_${evtName}`
      };
      body["properties"] = {
        page_name: pageName
      };
      if (properties && Object.keys(properties).length) {
        Object.assign(body["properties"], properties);
      }
      this.setCCGlobalObj();
      Object.assign(body["properties"], this.ccGlobalObj);
      this.$store.dispatch("sendCleverTapEvent", body);
    },

    formatPrice(price) {
      if (!price && price != 0) {
        return null;
      }
      price = price.toString();
      let afterPoint = "";
      if (price.indexOf(".") > 0)
        afterPoint = price.substring(price.indexOf("."), price.length);
      price = price > 0 ? Math.floor(price) : Math.ceil(price);
      price = price.toString();
      let lastThree = price.substring(price.length - 3);
      let otherNumbers = price.substring(0, price.length - 3);
      if (!Number.isNaN(parseInt(otherNumbers)) && otherNumbers != "")
        lastThree = "," + lastThree;
      let res =
        otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        lastThree +
        afterPoint;
      return res;
    },
    dateParamFormatter(num) {
      return num < 10 ? `0${num}` : num;
    },
    formatDate(date) {
      return `${this.dateParamFormatter(
        new Date(date).getDate()
      )}/${this.dateParamFormatter(new Date(date).getMonth() + 1)}/${new Date(
        date
      ).getFullYear()}`;
    },
    openSheet(props) {
      this.$store.commit("SET_SHEET_STATE", true);
      this.$store.commit("SET_SHEET_DATA", props);

      //disable background scroll
      document.getElementById("credit-app").style.overflowY = "hidden";
    },
    handleSheetClose(sheetDataObj) {
      this.$store.commit("SET_SHEET_STATE", false);
      sheetDataObj && sheetDataObj.sheetHandler && sheetDataObj.sheetHandler();
      this.$store.commit("RESET_SHEET_DATA");

      //enable background scroll
      document.getElementById("credit-app").style.overflowY = "auto";
    },
    closeWebView() {
      window.location = "back:selfServe";
    },
    setCCGlobalObj() {
      if (this.ccGlobalObj && !Object.keys(this.ccGlobalObj).length) {
        for (let key in owConfig.metaData) {
          this.ccGlobalObj[key] = owConfig.metaData[key];
        }
      }
    },
    encodeBase64(obj) {
      //safe encoding to support characters out of Latin1 scope(for eg: '₹')
      if (!obj || !Object.keys(obj).length) {
        return;
      }
      return btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    },
    decodeBase64(hash) {
      //safe decoding
      if (!hash) {
        return;
      }

      return JSON.parse(decodeURIComponent(escape(atob(hash))));
    },
    capitalizeString(string) {
      let str = string.toLowerCase();
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    publishCCEvent(evtName, pageName, attrs) {
      this.setCCGlobalObj();
      const eventData = {
        name: `ofs_cc_${evtName}`,
        timestamp: this._currentTimeMillis(),
        attrs: attrs ? attrs : {}
      };
      eventData.attrs.page_name = pageName || undefined;
      eventData.attrs.pitch_version = this.$store.getters.getCCPitchPageVersion;
      Object.assign(eventData.attrs, this.ccGlobalObj);

      const isWithAuth =
        this.$store.state.credentials &&
        this.$store.state.credentials.accessToken;

      if (isWithAuth) {
        this.$store.dispatch("publishEvent", [eventData]);
      } else {
        this.$store.dispatch("publishPublicEvent", [eventData]);
      }
    },
    getCCEarlyBirdExpiryDate() {
      const monthsArr = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov",
          "Dec"
        ],
        dateObj = new Date(),
        currDay = dateObj.getDate(),
        currMonth = dateObj.getMonth(),
        currYear = dateObj.getFullYear();

      let expiryText;

      if (currDay < 15) {
        expiryText = `${new Date(currYear, currMonth + 1, 0).getDate()} ${
          monthsArr[currMonth]
        }`;
      } else {
        expiryText = `15 ${monthsArr[(currMonth + 1) % 12]}`;
      }

      return expiryText;
    },
    goBack() {
      this.$router.go(-1);
    },
    encodeBase64(obj) {
      //safe encoding to support characters out of Latin1 scope(for eg: '₹')
      if (!obj || !Object.keys(obj).length) {
        return;
      }
      return btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    },
    decodeBase64(hash) {
      //safe decoding
      if (!hash) {
        return;
      }
      return JSON.parse(decodeURIComponent(escape(atob(hash))));
    },
    showGenericErrorSheet(pageName) {
      const sheetProps = {
        heading: "Oops!",
        subheading: "Something went wrong. Please try again later.",
        buttonText: "Okay",
        imgSrc: "images/cc_onboard/Creative_for_failure.svg",
        idProp: "ccFormErrorPopup"
      };
      this.openSheet(sheetProps);
      this.publishCCEvent("error_empty_field_form_next", pageName, {});
    },
    goToExternalLink(url) {
      if (typeof JSInterface !== "undefined") {
        JSInterface.handleExternalUrl && JSInterface.handleExternalUrl(url);
      } else {
       // Raven.captureException("JSInterface is not defined!");
      }
    },
    openAppStore() {
      let os_appstore_map = {
        android: {
          cabsapp: window.owConfig.olaCabsPlayStoreLink,
          omapp: window.owConfig.olaMoneyPlayStoreLink
        },
        ios: {
          cabsapp: window.owConfig.olaCabsAppStoreLink,
          omapp: window.owConfig.olaMoneyAppStoreLink
        }
      };

      let tenant = window.owConfig.tenant || "cabsApp"; // Missing tenant systems will be considered as cabsApp
      tenant = tenant.toLowerCase();

      let os = window.owConfig.os_name.toLowerCase() || "android"; // default to android
      let url = os_appstore_map[os][tenant];

      if (url) {
        if (
          typeof JSInterface !== "undefined" &&
          JSInterface.handleExternalUrl
        ) {
          // For App
          JSInterface.handleExternalUrl(url);
        } else {
          // For non-app tenants like Desktop browser...etc
          // Opens link in new tab or window
          window.open(url, "_blank");
        }
      } else {
        // Raven.captureException(
        //   new Error("No app store url for this OS and Tenant")
        // );
      }
    }
  }
});
